<template>
  <v-container fluid>
    <div>
      <h1 class="text-center mt-5 mb-5" v-if="startDateToFilter !== null">
        <v-icon class="arrow mt-n1" @click="calendarType === 'month' ? prevMonth() : prevWeek()" small>fa-chevron-left</v-icon>
        {{ monthNames[startDateToFilter.getMonth()] }} {{ startDateToFilter.getFullYear() }}
        <v-icon class="arrow mt-n1" @click="calendarType === 'month' ? nextMonth() : nextWeek()" small>fa-chevron-right</v-icon>
        <v-btn v-if="calendarType === 'week'" 
               @click="backToMonthView" 
               class="back-to-month-btn"
               elevation="0">
          <v-icon small class="mr-4" style="color: white !important;" color="white">fa-calendar-alt</v-icon>
          {{ $t('backToMonth') }}
        </v-btn>
      </h1>
      <ChannelSelect class="text-center d-flex justify-end" :current-module="this.$i18n.locale === 'en'? 'Events' : 'Eventos'"/>
      <v-calendar ref="calendarCommunity" 
                  :events="events" 
                  :now="today" 
                  :value="today" 
                  v-model="focus"
                  :type="calendarType"
                  :weekdays="[0, 1, 2, 3, 4, 5, 6]"
                  :color="`${this.$store.state.clubMember.club.primaryColor}`"
                  style="min-height: 70vh" 
                  @change="calendarChanged" 
                  @click:event="showEvent"
                  @click:date="handleDayNumberClick"
                  @click:day="handleDayBoxClick"
                  @click:time="handleTimeClick"
                  :first-time="7 * 60"
                  :interval-minutes="30"
                  :interval-height="40"
                  :event-more="true"
                  :event-more-text="$t('moreEvents')"
                  :max-events="3"
                  :event-ripple="false"
                  @click:more="showMoreEvents"/>
      <v-menu v-model="selectedOpen" :close-on-content-click="false" :activator="selectedElement" offset-x>
        <v-card min-width="350px" max-width="350px" flat>
          <v-toolbar :color="`#${this.$store.state.clubMember.club.primaryColor}`" elevation="0" >
            <h2 style="color: #FFFFFF">{{ selectedEvent.name }} <br><span>{{ $t('at') }} {{ selectedEvent.start }}</span></h2>
            <v-spacer></v-spacer>
            <v-icon class="icon" color="white" @click="selectedOpen = false">fa-times</v-icon>
          </v-toolbar>
          <v-card-text>
            <p class="mb-0" v-if="selectedEvent.details !== undefined"
               v-html="linkify(selectedEvent.details.description)"/>
          </v-card-text>
          <v-card-actions
              v-if="selectedEvent.details !== undefined && selectedEvent.details.clubMember.id === this.$store.state.clubMember.id">
            <v-chip @click="deleteEvent(selectedEvent.details)" class="ml-2 mb-2" small>
              <p style="font-size: 13px;" class="mb-0">{{ $t('btnDelete_ClubEvents') }}
                <v-icon class="ml-1" x-small>fa-trash</v-icon>
              </p>
            </v-chip>
          </v-card-actions>
        </v-card>
      </v-menu>
    </div>

    <!-- Overlay show event !-->
    <v-overlay :dark="false" v-model="overlayShowDay">

    </v-overlay>
    <!-- Overlay for add event !-->
    <v-overlay :dark="false" :value="overlayAddEvent">
      <AddEvent 
        :selected-date="selectedDate"
        @closeWindow="closeAddEventOverlay"/>
    </v-overlay>
    <!-- Overlay for delete event !-->
    <v-overlay :dark="false" :value="overlayDeleteEvent">
      <DeleteEvent :event="currentEvent" @closeWindow="overlayDeleteEvent = false"/>
    </v-overlay>
    <!-- Overlay for showing all events of a day !-->
    <v-overlay :dark="false" :value="showAllEvents">
      <v-card class="all-events-card" max-width="400">
        <v-toolbar :color="`#${this.$store.state.clubMember.club.primaryColor}`" dark>
          <v-toolbar-title>{{ selectedDayEvents.date }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="showAllEvents = false">
            <v-icon>fa-times</v-icon>
          </v-btn>
        </v-toolbar>
        <v-list>
          <v-list-item v-for="event in selectedDayEvents.events" :key="event.start">
            <v-list-item-content>
              <v-list-item-title>{{ event.name }}</v-list-item-title>
              <v-list-item-subtitle>{{ event.start }}</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-card>
    </v-overlay>
    <CalendarTutorial 
      v-if="showTutorial && this.$store.state.clubMember.rol !== 'MEMBER'"
      :show="showTutorial"
      @close="showTutorial = false"
    />
  </v-container>
</template>

<script>
import Repository from '../../../repositories/club';
import { mapMutations } from 'vuex';
import AddEvent from "@/views/Community/components/AddEvent";
import DeleteEvent from "@/views/Community/components/DeleteEvent";
import CalendarTutorial from './CalendarTutorial.vue'
import ChannelSelect from "@/views/Community/components/ChannelSelect";
import { linkify } from "@/utils/safeHtml";

export default {
  name: "ClubEvents",
  components: {DeleteEvent, AddEvent, CalendarTutorial, ChannelSelect},
  data() {
    return {
      overlayShowDay: false,
      overlayAddEvent: false,
      overlayDeleteEvent: false,
      currentEvent: null,
      today: '',
      focus: '',
      startDateToFilter: null,
      endDateToFilter: null,
      selectedEvent: {},
      selectedElement: null,
      selectedOpen: false,
      monthTrades: [],
      monthNames: [
        this.$t('months.jan'),
        this.$t('months.feb'),
        this.$t('months.mar'),
        this.$t('months.apr'),
        this.$t('months.may'),
        this.$t('months.jun'),
        this.$t('months.jul'),
        this.$t('months.aug'),
        this.$t('months.sep'),
        this.$t('months.oct'),
        this.$t('months.nov'),
        this.$t('months.dec')
      ],
      events: [],
      selectedDate: null,
      calendarType: 'month',
      usedColors: new Set(), // Track used colors
      baseColors: [
        '#FF6B6B', '#4ECDC4', '#45B7D1', '#96CEB4', '#FFEEAD',
        '#D4A5A5', '#9B59B6', '#3498DB', '#E67E22', '#2ECC71',
        '#1ABC9C', '#F1C40F', '#E74C3C', '#34495E', '#16A085'
      ],
      showAllEvents: false,
      selectedDayEvents: {
        date: '',
        events: []
      },
      showTutorial: false
    };
  },
  computed: {
    clubColor() {
      return `#${this.$store.state.clubMember.club.primaryColor}`;
    }
  },
  mounted() {
    this.init();
    this.checkShowTutorial();
    // Inject club color as CSS variable
    document.documentElement.style.setProperty('--club-color', this.clubColor);
  },
  beforeDestroy() {
    // Clean up CSS variable when component is destroyed
    document.documentElement.style.removeProperty('--club-color');
  },
  watch: {
    '$store.state.clubEvents': function () {
      this.processEvents();
    },
    '$store.state.currentClubChannel': function () {
      this.refreshEvents();
    },
  },
  methods: {
    ...mapMutations(['setClubEvents']),
    refreshEvents() {
      Repository.getAllClubEventsByChannel(this.$store.state.clubMember.club.id, this.$store.state.currentClubChannel.id).then((response) => {
        if(response.status < 400)
          this.setClubEvents(response.data);
      });
    },
    ...mapMutations(['setClubEvents']),
    init() {
      this.today = this.getToday();
      this.$refs.calendarCommunity.checkChange();
      this.refreshEvents();
    },
    getToday() {
      this.focus = '';
      let today = new Date();
      this.startDateToFilter = new Date(today.getFullYear(), today.getMonth());
      this.endDateToFilter = new Date(today.getFullYear(), today.getMonth(), today.getDate());
      return `${today.getFullYear()}-${today.getMonth() + 1}-${today.getDate()} ${today.getHours()}:${today.getMinutes()}`;
    },
    async calendarChanged({start, end}) {
      await this.refreshDates(start, end);
    },
    async refreshDates(start, end) {
      this.$refs.calendarCommunity.checkChange();
      this.startDateToFilter = new Date(`${start.date}T00:00:00`);
      this.endDateToFilter = new Date(`${end.date}T23:59:59`);
    },
    prevMonth() {
      this.$refs.calendarCommunity.prev();
    },
    nextMonth() {
      this.$refs.calendarCommunity.next();
    },
    prevWeek() {
      this.$refs.calendarCommunity.prev();
    },
    nextWeek() {
      this.$refs.calendarCommunity.next();
    },
    processEvents() {
      this.events = [];
      this.usedColors.clear(); // Reset colors when reprocessing events
      
      this.$store.state.clubEvents.forEach((event) => {
        this.events.push({
          name: event.name,
          start: this.formatDate(event.startDate),
          end: this.formatDate(event.endDate),
          details: event,
          color: this.getUniqueColor(), // Assign unique color to each event
        });
      });
    },
    formatDate(stringDate) {
      let date = new Date(stringDate);
      return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2,0)}-${String(date.getDate()).padStart(2,0)} ${String(date.getHours()).padStart(2,0)}:${String(date.getMinutes()).padStart(2, 0)}`;
    },
    showEvent ({ nativeEvent, event }) {
      // eslint-disable-next-line no-console
      console.log('Hereee');
      const open = () => {
        this.selectedEvent = event;
        this.selectedElement = nativeEvent.target;
        setTimeout(() => {
          this.selectedOpen = true;
        }, 10);
      }

      if (this.selectedOpen) {
        this.selectedOpen = false;
        setTimeout(open, 10);
      } else
        open();

      nativeEvent.stopPropagation();
    },
    deleteEvent(event) {
      this.currentEvent = event;
      this.selectedOpen = false;
      this.overlayDeleteEvent = true;
    },
    showDay() {
      this.overlayShowDay = true;
    },
    linkify(inputText) {
      // HTML-escapes user text before adding anchors (stored-XSS fix)
      return linkify(inputText);
    },
    handleDayClick(date) {
      if (this.$store.state.clubMember.rol === 'MEMBER') return;
      this.selectedDate = date.date;
      this.overlayAddEvent = true;
    },
    handleDayNumberClick({ date, nativeEvent }) {
      // Switch to week view when clicking day number
      if (this.calendarType === 'month') {
        this.calendarType = 'week';
        this.focus = date;
      }
      nativeEvent.stopPropagation();
    },

    handleDayBoxClick({ date }) {
      if (this.calendarType === 'week') {
        // In week view, let handleTimeClick handle the click
        return;
      }
      
      // Only show create event modal if clicking the box in month view
      // and user is not a MEMBER
      if (this.$store.state.clubMember.rol !== 'MEMBER') {
        const selectedDate = new Date(date);
        const now = new Date();
        selectedDate.setHours(now.getHours());
        selectedDate.setMinutes(now.getMinutes());
        
        this.selectedDate = this.formatDate(selectedDate);
        this.overlayAddEvent = true;
      }
    },

    handleTimeClick({ date, hour, minute }) {
      if (this.$store.state.clubMember.rol === 'MEMBER') return;
      
      const selectedDate = new Date(date);
      selectedDate.setHours(hour);
      selectedDate.setMinutes(minute);
      
      this.selectedDate = this.formatDate(selectedDate);
      this.overlayAddEvent = true;
    },
    backToMonthView() {
      this.calendarType = 'month';
    },
    closeAddEventOverlay() {
      this.overlayAddEvent = false;
      this.selectedDate = null;
    },
    getUniqueColor() {
      // First try to use one of the base colors
      for (const color of this.baseColors) {
        if (!this.usedColors.has(color)) {
          this.usedColors.add(color);
          return color;
        }
      }

      // If all base colors are used, generate a random color
      let newColor;
      do {
        const hue = Math.floor(Math.random() * 360);
        const saturation = 70 + Math.random() * 10; // 70-80%
        const lightness = 45 + Math.random() * 10;  // 45-55%
        newColor = `hsl(${hue}, ${saturation}%, ${lightness}%)`;
      } while (this.usedColors.has(newColor));

      this.usedColors.add(newColor);
      return newColor;
    },
    showMoreEvents({ date, events }) {
      this.selectedDayEvents = {
        date: this.formatDayHeader(date),
        events: events
      };
      this.showAllEvents = true;
    },
    
    formatDayHeader(date) {
      const eventDate = new Date(date);
      return `${this.monthNames[eventDate.getMonth()]} ${eventDate.getDate()}, ${eventDate.getFullYear()}`;
    },
    checkShowTutorial() {
      const tutorialCompleted = localStorage.getItem('calendar-tutorial-completed');
      if (!tutorialCompleted) {
        this.$nextTick(() => {
          const calendar = document.querySelector('.v-calendar');
          if (calendar) {
            calendar.scrollIntoView({ behavior: 'smooth', block: 'center' });
            setTimeout(() => {
              this.showTutorial = true;
            }, 500);
          }
        });
      }
    }
  }
}
</script>



<style lang="scss" scoped>
  .arrow {
    color: #929292 !important;
    border: none !important;
  }

  .arrow:hover {
    color: #929292 !important;
    background-color: transparent !important;
    border: none !important;
  }

  .arrow:focus {
    color: #929292 !important;
    background-color: transparent !important;
    border: none !important;
  }

  .button-add {
    background-color: #111111 !important;
    color: #ffffff !important;
    border: #111111 solid 1px;
  }

  /* Add these new styles */
  ::v-deep .v-calendar-weekly__head-weekday {
    background-color: var(--club-color) !important;
    color: white !important;
    border: none !important;
    padding: 10px;
    font-weight: bold !important;
  }

  /* Optional: if you want to adjust the height of the weekday header */
  ::v-deep .v-calendar-weekly__head {
    margin-bottom: 2px;
  }

  /* Add styles for current day */
  ::v-deep .v-calendar-weekly__day.v-present {
    background-color: rgba(216, 30, 30, 0.1) !important; /* Soft red that matches your theme */
  }

  /* Add hover styles for day cells */
  ::v-deep .v-calendar-weekly__day {
    cursor: pointer;
  }

  /* Optional: add subtle hover effect */
  ::v-deep .v-calendar-weekly__day:hover {
    background-color: rgba(0, 0, 0, 0.03);
    transition: background-color 0.2s ease;
  }

  .back-to-month-btn {
    font-family: 'Avenir', sans-serif !important;
    background-color: var(--v-mainGreen-base) !important;
    color: white !important;
    text-transform: none !important;
  }

  .back-to-month-btn:hover {
    opacity: 0.9;
  }

  /* Current day styling in weekly view */
  ::v-deep .v-calendar-weekly__day.v-present.v-week-view {
    background-color: rgba(216, 30, 30, 0.05) !important;
    border-left: 3px solid var(--club-color) !important;
  }

  /* Style for current time line in week view */
  ::v-deep .v-calendar-weekly__day.v-present.v-week-view .v-calendar-weekly__day-current-time {
    border-color: var(--club-color) !important;
    background-color: var(--club-color) !important;
  }

  /* Add background for current hour */
  ::v-deep .v-calendar-weekly__day.v-present.v-week-view .v-calendar-weekly__day-current {
    background-color: rgba(216, 30, 30, 0.1) !important;
  }

  /* Weekly view current day styles */
  ::v-deep .v-calendar-weekly.v-calendar-weekly--week {
    .v-calendar-weekly__day.v-present {
      background-color: red !important;
      position: relative;
    }

    .v-calendar-weekly__day.v-present::before {
      content: '';
      position: absolute;
      left: 0;
      top: 0;
      bottom: 0;
      width: 4px;
      background-color: #d81e1e;
    }
  }

  /* Current time indicator in week view */
  ::v-deep .v-calendar-weekly__day-current-time {
    background-color: var(--club-color) !important;
    height: 2px !important;
  }

  ::v-deep .v-calendar-weekly__day-current-time::after {
    content: '';
    position: absolute;
    right: -4px;
    border-radius: 50%;
    width: 8px;
    height: 8px;
    background-color: var(--club-color);
    transform: translateY(-3px);
  }

  /* Make day number more visible as clickable */
  ::v-deep .v-calendar-weekly__day-label {
    cursor: pointer;
    border-radius: 50%;
    width: 24px;
    height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: background-color 0.2s ease;
  }

  ::v-deep .v-calendar-weekly__day-label:hover {
    background-color: rgba(216, 30, 30, 0.1);
  }

  /* Style for time slots in week view */
  ::v-deep .v-calendar-weekly__day-timelines {
    cursor: pointer;
  }

  ::v-deep .v-calendar-weekly__day-timeline:hover {
    background-color: rgba(216, 30, 30, 0.05);
  }

  .all-events-card {
    border-radius: 8px;
  }

  /* Style for the "more" button in calendar */
  ::v-deep .v-calendar-weekly__day-more {
    font-family: 'Avenir', sans-serif;
    color: var(--club-color) !important;
    font-size: 12px;
    cursor: pointer;
    padding: 2px 4px;
    border-radius: 4px;
    margin-top: 2px;
    
    &:hover {
      background-color: rgba(216, 30, 30, 0.1);
    }
  }

  /* Update the more events indicator style */
  ::v-deep .v-calendar-weekly__day {
    .v-event-more {
      position: relative;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      font-size: 12px;
      padding: 2px 4px;
      cursor: pointer;
      color: var(--club-color) !important;
      margin-top: 2px;
      background-color: color-mix(in srgb, var(--club-color) 10%, transparent);
      border-radius: 4px;
      font-family: 'Avenir', sans-serif;

      &:hover {
        background-color: color-mix(in srgb, var(--club-color) 20%, transparent);
      }
    }
  }

  /* Fix event container to respect max events */
  ::v-deep .v-calendar-weekly__day-container {
    max-height: calc(24px * 3 + 20px); /* Height of 3 events plus padding */
    overflow: hidden;
  }
</style>
